import { Component, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { AssistantService } from '../../../common/assistant.service';
import { ValidationService } from '../../../common/validation.service';
import { ValueListsService } from '../../../common/value-lists.service';
import { ValueListItem } from '../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-beruf-kurzfristiger-aufenthalt',
  templateUrl: './beruf-kurzfristiger-aufenthalt.component.html',
  styleUrls: ['./beruf-kurzfristiger-aufenthalt.component.scss']
})
export class BerufKurzfristigerAufenthaltComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {
  private landListItemsSub: Subscription;
  landListItems: ValueListItem[];

  private berufListItemsSub: Subscription;

  berufListItems: ValueListItem[];


  constructor(fb: FormBuilder,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              assistantService: AssistantService,
              assistantPopoverService: AssistantPopoverService,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      berufAuswahl: [null, validationService.getValidators('antragsteller.personendaten.berufdaten.berufAuswahl')],
      firmenname: [null, validationService.getValidators('antragsteller.personendaten.berufdaten.firmenname')],
      firmenTelefonNr: [null, validationService.getValidators('antragsteller.personendaten.berufdaten.firmenTelefonNr')],
      strasse: [null, validationService.getValidators('antragsteller.personendaten.berufdaten.strasse')],
      hausnummer: [null, validationService.getValidators('antragsteller.personendaten.berufdaten.hausnummer')],
      sonstigeAdressangaben: [null, validationService.getValidators('antragsteller.personendaten.berufdaten.sonstigeAdressangaben')],
      plz: [null, validationService.getValidators('antragsteller.personendaten.berufdaten.plz')],
      ort: [null, validationService.getValidators('antragsteller.personendaten.berufdaten.ort')],
      land: [null, validationService.getValidators('antragsteller.personendaten.berufdaten.land')]
    }));
  }

  ngOnInit() {

    super.ngOnInit();

    this.landListItemsSub = this.valueListsService.getValueListItems('land')
    .subscribe((listItems: ValueListItem[]) => this.landListItems = listItems);

    this.berufListItemsSub = this.valueListsService.getValueListItems('beruf')
    .subscribe((listItems: ValueListItem[]) => this.berufListItems = listItems);

  }

  ngOnDestroy(): void {
    this.landListItemsSub.unsubscribe();
    this.berufListItemsSub.unsubscribe();
  }
}
